import React from 'react';

const BreakCardDesign = () => {
  return (
    <div
      className='
      flex items-center justify-center
      w-full min-h-[100px] py-6 px-4
      bg-white rounded-lg
      '
      style={{
        backgroundImage: `
          repeating-linear-gradient(
            45deg,
            transparent,
            transparent 10px,
            rgba(220, 20, 60, 0.05) 10px,
            rgba(220, 20, 60, 0.05) 20px
          )`
      }}
    >
      <div className='text-gray-400 text-lg font-mono select-none'></div>
    </div>
  );
};

export default BreakCardDesign;
